import moment from 'moment'
moment.locale('id')

import { formatIndexDate } from '@/helpers/tzDate'
import { formatDateFields } from '../constants/formatFields'

export function formatDate(value) {
  const date = formatIndexDate(value).date
  const time = formatIndexDate(value).time
  if (date == '-' || time == '-') return '-'
  return `${date} ${time}`
}

export function formatDuration(durationISO8601) {
  const duration = moment.duration(durationISO8601)

  const days = duration.days()
  const hours = duration.hours()

  const formattedDuration = []

  if (days > 0) {
    formattedDuration.push(`${days} Hari`)
  }

  if (hours > 0) {
    formattedDuration.push(`${hours} Jam`)
  }

  if (formattedDuration.length == 0) {
    formattedDuration.push('- Jam')
  }

  return formattedDuration.join(' ')
}

export function formatValues(key, value) {
  if (formatDateFields.includes(key)) return formatDate(value)
  if (key === 'delivered_duration') return formatDuration(value)

  return value || '-'
}
